<template>
  <div class="flex items-center">
    <div class="cursor-pointer" @click="handleClick">{{ props.label }}</div>
    <arrow-narrow-up class="w-3 h-3 ml-1" v-if="direction === 'asc'" />
    <arrow-narrow-down class="w-3 h-3 ml-1" v-if="direction === 'desc'" />
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from "vue";
import ArrowNarrowDown from "@/Tailwind/Icon/ArrowNarrowDown";
import ArrowNarrowUp from "@/Tailwind/Icon/ArrowNarrowUp";

const SORT_ASC = "asc";
const SORT_DESC = "desc";

const props = defineProps({
  label: String,
  column: String,
  value: String,
});

const emit = defineEmits(["sort", "update:modelValue"]);

const direction = computed(() => props.value);

function handleClick() {
  const sortValue = props.value === SORT_ASC ? SORT_DESC : SORT_ASC;

  emit("update:modelValue", sortValue);
  emit("sort", props.column, sortValue);
}
</script>

<style scoped></style>
